import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import LinearProgress from "@mui/material/LinearProgress";
import Button from "@mui/material/Button";
import Alert from "@mui/material/Alert";
import type { VerificationSummary } from "./useSiteListActions";
import { VerificationBreakdown } from "./VerificationBreakdown";
import type { JSX } from "react";

interface VerificationProgressProps {
  kind: "starting" | "progress" | "completed" | "error";
  summary: VerificationSummary | null;
  errorMessage: string | null;
  onDismiss: () => void;
  onCancel: () => void;
}

export function VerificationProgress(props: VerificationProgressProps) {
  let verificationProgress: JSX.Element | null;
  const { kind, summary, errorMessage, onDismiss, onCancel } = props;
  if (kind === "starting") {
    verificationProgress = (
      <Alert severity="info" sx={{ mb: 2 }}>
        Запуск проверки доступов...
      </Alert>
    );
  } else {
    if (kind === "error") {
      verificationProgress = (
      <Alert severity="error" sx={{ mb: 2 }} action={<Button size="small" onClick={onDismiss}>Закрыть</Button>}>
        Ошибка проверки: {errorMessage}
      </Alert>
    );
    } else {
      if (kind === "completed" && summary) {
        verificationProgress = (
      <Alert severity="success" sx={{ mb: 2 }} action={<Button size="small" onClick={onDismiss}>Закрыть</Button>}>
        <Typography variant="body2">
          Проверка завершена. Проверено {summary.totalSites} сайтов / {summary.totalCredentials} доступов.
        </Typography>
        <Typography variant="body2" sx={{ mt: 0.5 }}>
          Article: {summary.sitesArticleValidCount} из {summary.totalSites} сайтов валидны {VerificationBreakdown.article(summary)} / {summary.sitesArticleInvalidCount} невалидных
        </Typography>
        <Typography variant="body2" sx={{ mt: 0.5 }}>
          Homepage: {summary.sitesHomepageValidCount} из {summary.totalSites} сайтов валидны {VerificationBreakdown.homepage(summary)} / {summary.sitesHomepageInvalidCount} невалидных
        </Typography>
        <Typography variant="body2" sx={{ mt: 0.5 }}>
          Sitewide: {summary.sitesPluginSitewideValidCount} из {summary.totalSites} сайтов валидны {VerificationBreakdown.sitewide(summary)} / {summary.sitesPluginSitewideInvalidCount} невалидных
        </Typography>
        <Typography variant="body2" sx={{ mt: 0.5 }}>
          Link-removal: {summary.sitesLinkRemovalValidCount} из {summary.totalSites} сайтов валидны {VerificationBreakdown.linkRemoval(summary)} / {summary.sitesLinkRemovalInvalidCount} невалидных
        </Typography>
      </Alert>
    );
      } else {
        if (kind === "progress" && summary) {
          const totalChecks = summary.totalCredentials + summary.totalSites;
          const doneChecks = summary.checkedCount + summary.sitesPluginCheckedCount;
          const percent = totalChecks > 0 ? (doneChecks / totalChecks) * 100 : 0;
          verificationProgress = (
      <Box sx={{ mb: 2 }}>
        <Box display="flex" justifyContent="space-between" alignItems="center" mb={0.5}>
          <Typography variant="body2">
            Проверка: доступы {summary.checkedCount} / {summary.totalCredentials}, плагин {summary.sitesPluginCheckedCount} / {summary.totalSites} сайтов
          </Typography>
          <Button size="small" color="error" onClick={onCancel}>
            Отменить
          </Button>
        </Box>
        <Box display="flex" justifyContent="flex-end" mb={0.5} gap={2}>
          <Typography variant="caption" color="text.secondary">
            Article: {summary.sitesArticleValidCount}/{summary.totalSites} сайтов {VerificationBreakdown.article(summary)} / {summary.sitesArticleInvalidCount} невалидных
          </Typography>
          <Typography variant="caption" color="text.secondary">
            Homepage: {summary.sitesHomepageValidCount}/{summary.totalSites} сайтов {VerificationBreakdown.homepage(summary)} / {summary.sitesHomepageInvalidCount} невалидных
          </Typography>
          <Typography variant="caption" color="text.secondary">
            Sitewide: {summary.sitesPluginSitewideValidCount}/{summary.totalSites} сайтов {VerificationBreakdown.sitewide(summary)} / {summary.sitesPluginSitewideInvalidCount} невалидных
          </Typography>
          <Typography variant="caption" color="text.secondary">
            Link-removal: {summary.sitesLinkRemovalValidCount}/{summary.totalSites} сайтов {VerificationBreakdown.linkRemoval(summary)} / {summary.sitesLinkRemovalInvalidCount} невалидных
          </Typography>
        </Box>
        <LinearProgress variant="determinate" value={percent} />
      </Box>
    );
        } else {
          verificationProgress = null;
        }
      }
    }
  }
  return verificationProgress;
}
